import React from "react";
import { ResetButton } from "../../components/ResetButton/ResetButton";
import { NetworkDropdown } from "../../components/NetworkDropdown/NetworkDropdown";
import { FlexContainer } from "../../containers/FlexContainer";
import { css } from "@emotion/react";

export const OrderEntryHeader: React.FC = () => {
  return (
    <FlexContainer
      css={css`
        padding: 0 26px;
        width: 100%;
      `}
    >
      <ResetButton />
      <NetworkDropdown />
    </FlexContainer>
  );
};
